module.exports = __webpack_public_path__ + "static/img/jl.8ff4e50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jl.png
// module id = peb8
// module chunks = 1